window.AreaDetails = (function() {
   var self = this,
      videoPlayer;

   /**
    * TODO Document This
    */
   function resizeDisplay() {
   }

   function initializeDisplay() {
      $('.collapse').each(function() {
         new Collapsasaurus($(this), 2, {
            expandText : '&hellip;view more'
         });
      });
   }

   function fixIe6() {
      var iBrowserVersion = $.browser.version.substr(0, 1);

      if ($.browser.msie && iBrowserVersion < 7) {
         // Displays above the gradient, but that's the least
         // of my worries in IE6
         $('#rightListingsRail').css({
            zIndex : 11
         });
      }
   }

   /**
    * Initialize the Right Rail Local Area Searches
    *
    */
   function initializeLocalAreaSearches() {
	  $("#rightRailLocalAreaSearch .c21OfficesSearch, #rightRailLocalAreaSearch .c21AgentsSearch, #rightRailLocalAreaSearch .c21PropertiesSearch").hover(
	     function() {
	        $(this).addClass('hover');
	     },
	     function() {
	    	 $(this).removeClass('hover');
	     }
	  );
   }

   function initialize() {
      videoPlayer = new window.LocalAreaVideoPlayer();
      videoPlayer.setupVideos();

      $(document).ready(function() {
    	 // Set the search tab
    	 if (window.viewEngineName == 'findahomemap') {
            $("#findAHomeSearchTabs .searchTab.bymap, #findAHomeSearchNav .searchByState").addClass("selected");
    	 }

    	 if(window.viewEngineName == 'localArea') {
    		 initializeLocalAreaSearches();
    		 $("#localAreaDataSelect").change(function() {
    		    Track.doEvent('Local Area', 'Change Community', $('#localAreaDataSelect option:selected').text());
    		 });
    		 $("#localAreaIndexSelect").change(function() {
    			Track.doEvent('Local Area', 'Change National Index', $('#localAreaIndexSelect option:selected').text());
    		 });
    	 } else {
    		 $("#rightRailLocalAreaSearch, #rightRailLocalAreaSearchTitle").hide();
    	 }

    	 if (window.viewEngineName == 'findahomemapdetail') {
    		 $("#localAreaDataSelect").change(function() {
     		    Track.doEvent('Find a Home by State', 'Change Community', $('#localAreaDataSelect option:selected').text());
     		 });
     		 $("#localAreaIndexSelect").change(function() {
     			Track.doEvent('Find a Home by State', 'Change National Index', $('#localAreaIndexSelect option:selected').text());
     		 });
    	 }

         if (window.viewEngineName == 'findahomemapdetail' || window.viewEngineName == 'localArea') {
            MapMaster.initialize();

            ChartMaster.initialize();
            SchoolsData.initialize();
         }
      });

      //resizeDisplay();
      //fixIe6();


      initializeCollapsableStates();

//      $("#searchByMapDiv").hover(function() {
//      }, function() {
//      });
   }

   function initializeCollapsableStates() {
      $("#listingLaneContainer .stateContainer").each(function() {
         var jStateContainer = $(this),
               jStateInformation = jStateContainer.find('.stateInformationDiv'),
               bLockedOpen = false;

         jStateContainer.hoverIntent({
            over: function() {
               // Our slide animation lacks the vitamin C that fruit provides
               jStateInformation.slideDown();
               jHeader.addClass('active');
            },
            out: function() {
               if (bLockedOpen) return;
               jStateInformation.slideUp();
               jHeader.removeClass('active');
            },
            timeout: 0,
            interval: 200
         });
         var jHeader = jStateContainer.find('.stateHeader');
         jHeader.click(function(e) {
            if (bLockedOpen) {
               bLockedOpen = false;
               jStateInformation.slideUp();
               jHeader.removeClass('active');
            } else {
               bLockedOpen = true;
               jStateInformation.slideDown();
               jHeader.addClass('active');
            }

            e.preventDefault();
            return false;
         });
      });
   }

   function showHoverState(strStateAbbrev) {
      var strUrl = '/images/nationalmap/statehovers/'
         + strStateAbbrev.toLowerCase()
         + '-statehover.png',
         jMovingImage = $("#movingImage");

      // Wait a few milliseconds. There's no gaurantee
      // that the hover event for SHOWING a state will
      // trigger after the hover event for HIDING it.
      if ($.browser.msie && parseInt($.browser.version) < 9) {
         jMovingImage.show();
      } else {
         jMovingImage.stop(true, true).fadeIn({
            duration: 90
         });
      }

      jMovingImage.css({
         backgroundImage: 'url(' + strUrl + ')'
      }, {
         easing: 'easeInQuad',
         duration: 300
      });
   }

   function hideHoverState() {
      var jMovingImage = $("#movingImage");
      if ($.browser.msie && parseInt($.browser.version) < 9) {
         jMovingImage.hide();
      } else {
         jMovingImage.stop(true, true).fadeOut();
      }
   }

   $(document).ready(initialize);

   return {
      resizeDisplay : resizeDisplay,
      hideHoverState : hideHoverState,
      showHoverState : showHoverState
   }
}());

window.LocalAreaVideoPlayer = function () {
   var self = this,
      m_communityVideoPlayer,
      m_bCommunityVideo,
      m_bMarketVideo,
      m_jTranscriptSection;

   function setupAjaxVideo (fnFinish) {
	  // Check if sundaySky JS has been included on page
	  if(typeof(sundaySky) === "object") {
	     sundaySky.isMediaAvailable($("#sundayskyListingID").val(), sundaySkyAvailable, sundaySkyUnavailable);
	  }

      function sundaySkyUnavailable(sku) {
         //alert('not available, sku: ' + sku);
         $("#localAreaVideoSection, #localAreaTitleSection").remove();
         fnFinish();
      };

      function sundaySkyAvailable(verifiedSku) {
         //alert('available: ' + verifiedSku);
         var options = [];
         options.playerWidth = 638;
         options.playerHeight = 358;
         options.autoStart=false;
         sundaySky.create({sku : verifiedSku }, options);
         fnFinish();
      };
   };

   function showTranscript () {
      $("#sundaySkyTranscript").slideDown();
      $("#transcriptSection")
         .addClass("expanded")
         .find(".showhideLabel").text(window.internationalization.getString("Hide Transcript"));
   };

   function hideTranscript () {
      $("#sundaySkyTranscript").slideUp();
      $("#transcriptSection")
         .removeClass("expanded")
         .find(".showhideLabel").text(window.internationalization.getString("Show Transcript"));
   };

   function showTranscriptSection (bCommunityVideo) {
      var jShowing,
         jHiding;

      if (bCommunityVideo) {
         jShowing = $("#communityVideoTranscript");
         jHiding = $("#marketVideoTranscript");
      } else {
         jShowing = $("#marketVideoTranscript");
         jHiding = $("#communityVideoTranscript");
      }

      if (jShowing.length > 0) {
         $("#transcriptSection").addClass("shown");
         jShowing.show();
         jHiding.hide();
      } else {
         $("#transcriptSection").removeClass("shown");
      }
   }

   function onCommunityVideoTabClick () {
      showTranscriptSection(true);

      $("#communityVideoSection").show();
      $("#localAreaVideoSection").hide();

      $("#menuSwitch .tab").removeClass("selected");
      $("#tabCommunity").addClass("selected");
   };

   function onMarketVideoTabClick () {
      showTranscriptSection(false);

      $("#communityVideoSection").hide();
      $("#localAreaVideoSection").show();

      $("#menuSwitch .tab").removeClass("selected");
      $("#tabLocal").addClass("selected");
   };

   function setupMarketVideo () {
      $("#tabLocal").click(function () {
         onMarketVideoTabClick();

         if (m_communityVideoPlayer) {
            m_communityVideoPlayer.pause();
         }

         var iInterval = setInterval(function () {
            var jObject = $("#sundayskyDiv object");
            if ((jObject.length > 0) && (jObject.get(0).sendEvent)) {
               jObject.get(0).sendEvent("PLAY", true);
               clearInterval(iInterval);
            }
         }, 300);
      });
   };

   function setupCommunityVideo () {
      $.ajax({
         url: "/cmsassets/player/mediaplayer-5.8-licensed/jwplayer.js",
         dataType: "script",
         success: function () {
            var jCommunityVideo = $("#communityVideoSection")

            m_communityVideoPlayer = new CommunityVideoPlayer();

            $("#tabCommunity").click(function () {
               onCommunityVideoTabClick();
               m_communityVideoPlayer.setup();
               m_communityVideoPlayer.play();
            });

            $("#tabLocal").click(function () {
               jwplayer().remove();
            });

            if (jCommunityVideo.is(":visible")) {
               m_communityVideoPlayer.setup();
            }
         }
      });
   };

   function setupTranscript () {
      m_jTranscriptSection = $("#transcriptSection");

      $("#sundaySkyTranscript").hide();
      m_jTranscriptSection.find(".transcriptButtonSection").click(function () {
         if (m_jTranscriptSection.hasClass("expanded")) {
            hideTranscript();
         } else {
            showTranscript();
         }
      }).hover(function () {
         m_jTranscriptSection.addClass("hover");
      }, function () {
         m_jTranscriptSection.removeClass("hover");
      });
   };

   self.setupVideos = function () {
      setupAjaxVideo(function () {
         m_bCommunityVideo = ($("#communityVideoSection").length > 0);
         m_bMarketVideo = ($("#localAreaVideoSection").length > 0);

         if (m_bMarketVideo) {
            if (m_bCommunityVideo) {
               setupCommunityVideo();
            } else {
               $("#videos").addClass("singleVideo");
            }

            setupMarketVideo();
            onMarketVideoTabClick();
         } else if (m_bCommunityVideo) {
            $("#videos").addClass("singleVideo");
            setupCommunityVideo();
            onCommunityVideoTabClick();
         } else {
            return;
         }

         $("#videos").removeClass("noVideos");

         setupTranscript();
      });
   };
};

/**
 * Handles rendering of the BING map
 */
window.MapMaster = (function() {
   var m_location, m_veMap, m_iLat, m_iLon;

   return {
      initialize : function() {
         loadBingMaps(function() {
            if (!m_iLat) {
               $('#locationViewArea').hide();
               return;
            }

            // Create the map
            var jResultMap = $('#resultMap');
            jResultMap.css({ width: 750, height: 300 });

            var location = new Microsoft.Maps.Location(m_iLat, m_iLon);
            m_veMap = new Microsoft.Maps.Map(jResultMap.get(0), {
               credentials: "AqK6Xm4vKQ14R0qING7QBL3FFqQDNoHrM0xVWiVT9yyukhvj7q6TBcylAn6DbA0o",
               center: location,
               zoom: 11,
            });

            var pushPin = new Microsoft.Maps.Pushpin(location, {
               icon: '/images/map/house.png',
            });

            m_veMap.entities.push(pushPin);
         });
      },

      setLocation : function(iLat, iLon) {
         m_iLat = iLat;
         m_iLon = iLon;
      },

      getLocation : function() {
         return m_location;
      }
   }
}());

/**
 * This compatibility layer fixes the following issues:
 * - IE can not show an overlay over an image map
 *   without buggy and hackish PNG filtering
 * - IE7 does not like javascript-generated area map markup
 */
window.AreaMapCompatibilityLayer = function(jBackground) {
   var m_aShapes = [],
      m_jBackground = jBackground,
      m_shapeCurrent;

   /**
    * Basic rectangle. Nothing special.
    * @param x
    * @param y
    * @param width
    * @param height
    */
   function Rectangle(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
      this.nodeName = 'rect';
   }

   /**
    * Polygonal madness class-like-construct
    * @param aCoords  an array of object literal { x: ?, y: ? } coordinates
    */
   function Polygon(aCoords) {
      this.coords = aCoords;
      this.nodeName = 'poly';
   }

   /**
    * A road that never ends (does that tree look familiar?)
    * @param x
    * @param y
    * @param radius
    */
   function Circle(x, y, radius) {
      this.x = x;
      this.y = y;
      this.radius = radius;
      this.nodeName = 'circ';
   }

   /**
    * Is the given point in a rectangle?
    * @param pointX
    * @param pointY
    * @param rectX
    * @param rectY
    * @param rectWidth
    * @param rectHeight
    */
   function isPointInRect(pointX, pointY, rectX, rectY, rectWidth, rectHeight) {
      if (pointX < rectX) return false;
      if (pointY < rectY) return false;
      if (pointX > (rectX + rectWidth)) return false;
      if (pointY > (rectY + rectHeight)) return false;
      return true;
   }

   /**
    * Determine whether a point is inside of a polygon
    * Source: Jonas Raoni Soares Silva
    * http://jsfromhell.com/math/is-point-in-poly [v1.0]
    */
   function isPointInPoly(pointX, pointY, poly){
      for(var c = false, i = -1, l = poly.length, j = l - 1; ++i < l; j = i)
         ((poly[i].y <= pointY && pointY < poly[j].y) || (poly[j].y <= pointY && pointY < poly[i].y))
         && (pointX < (poly[j].x - poly[i].x) * (pointY - poly[i].y) / (poly[j].y - poly[i].y) + poly[i].x)
         && (c = !c);
      return c;
   }

   /**
    * Is the given point in a bigger point?
    * @param pointX
    * @param pointY
    * @param circleX
    * @param circleY
    * @param radius
    */
   function isPointInCircle(pointX, pointY, circleX, circleY, radius) {
      return (Math.pow(pointX - circleX, 2) + Math.pow(pointY - circleY, 2)) < Math.pow(radius, 2);
   }

   /**
    * Add a rectangle!
    * @param x
    * @param y
    * @param width
    * @param height
    */
   this.addRect = function(x, y, width, height) {
      var rectangle = new Rectangle(x, y, width, height);
      m_aShapes.push(rectangle);
      return rectangle;
   }

   /**
    * Add a circle
    * @param x
    * @param y
    * @param radius
    */
   this.addCircle = function(x, y, radius) {
      var circle = new Circle(x, y, radius);
      m_aShapes.push(circle);
      return circle;
   }

   /**
    * Add a bunch of points that happen to form a polygon
    * @param aCoords  an array of { x: ?, y: ? } coordinates
    */
   this.addPolygon = function(aCoords) {
      var polygon = new Polygon(aCoords);
      m_aShapes.push(polygon);
      return polygon;
   }

   function onMouseEvent(event) {
      var offsetCanvas = m_jBackground.offset(),
         x = event.pageX - offsetCanvas.left,
         y = event.pageY - offsetCanvas.top,
         shapeNew;

      $.each(m_aShapes, function(i, shape) {
         switch (shape.nodeName) {
            case 'rect':
               if (isPointInRect(x, y, shape.x, shape.y, shape.width, shape.height)) {
                  shapeNew = shape;
                  return false;
               }
               break;

            case 'poly':
               if (isPointInPoly(x, y, shape.coords)) {
                  shapeNew = shape;
                  return false;
               }
               break;

            case 'circ':
               if (isPointInCircle(x, y, shape.x, shape.y, shape.radius)) {
                  shapeNew = shape;
                  return false;
               }
               break;
         }
      });

      if (shapeNew != m_shapeCurrent) {
         if (m_shapeCurrent) $(m_shapeCurrent).trigger('areaMouseOut', event);
         if (shapeNew) $(shapeNew).trigger('areaMouseOver', event);
      }

      m_shapeCurrent = shapeNew;
   }

   /**
    * Begin checking the outside world for events
    */
   this.pollMouseEvents = function() {
      m_jBackground.mousemove(onMouseEvent).click(function(event) {
         onMouseEvent(event);

         if (m_shapeCurrent) {
            $(m_shapeCurrent).trigger('areaMouseClick');
         }
      });
   }

   /**
    * Draw an outline of all the polygons added so far
    */
   this.drawMapOutline = function() {
      // The canvas must START with the correct size
      var jCanvas = $("<canvas height='" + m_jBackground.height() +
            "' width='" + m_jBackground.width() + "'></canvas>");
         elCanvas = jCanvas.get(0),
         context = elCanvas.getContext("2d"),
         backgroundOffset = m_jBackground.offset();

      jCanvas.css({
         position: 'absolute',
         left: backgroundOffset.left,
         top: backgroundOffset.top,
         border: '1px solid blue'
      });

      $(document.body).append(jCanvas);

      context.fillStyle = "rgba(0, 0, 200, 0.2)";
      context.strokeStyle = "rgba(200, 0, 0, 0.8)";

      $.each(m_aShapes, function(i, shape) {
         switch (shape.nodeName) {
            case 'rect':
               context.fillRect(shape.x, shape.y, shape.width, shape.height);
               context.strokeRect(shape.x, shape.y, shape.width, shape.height);
               break;

            case 'poly':
               context.beginPath();
               $.each(shape.coords, function(i, coord) {
                  if (i == 0) {
                     context.moveTo(coord.x, coord.y);
                     return true;
                  }
                  context.lineTo(coord.x, coord.y);
               });
               context.closePath();
               context.fill();
               context.stroke();
               break;

            case 'circ':
               context.beginPath();
               context.arc(shape.x, shape.y, shape.radius, 0, Math.PI * 2, true);
               context.closePath();
               context.fill();
               context.stroke();
               break;
         }
      });
   }
}

/**
 * IMPORTANT: Do not remove this code!!!
 *
 * This is the code used to generate the map coordinates.
 *
 * It should be saved in the event that we use a map of a different
 * scale, or if states are repositioned.
 */
window.MapGenerator = function() {
   var m_area, m_aAreas = [],
      m_stateLookup = {
         "Alabama":"AL",
         "Alaska":"AK",
         "Arizona":"AZ",
         "Arkansas":"AR",
         "California":"CA",
         "Colorado":"CO",
         "Connecticut":"CT",
         "Delaware":"DE",
         "Florida":"FL",
         "Georgia":"GA",
         "Hawaii":"HI",
         "Idaho":"ID",
         "Illinois":"IL",
         "Indiana":"IN",
         "Iowa":"IA",
         "Kansas":"KS",
         "Kentucky":"KY",
         "Louisiana":"LA",
         "Maine":"ME",
         "Maryland":"MD",
         "Massachusetts":"MA",
         "Michigan":"MI",
         "Minnesota":"MN",
         "Mississippi":"MS",
         "Missouri":"MO",
         "Montana":"MT",
         "Nebraska":"NE",
         "Nevada":"NV",
         "New Hampshire":"NH",
         "New Jersey":"NJ",
         "New Mexico":"NM",
         "New York":"NY",
         "North Carolina":"NC",
         "North Dakota":"ND",
         "Ohio":"OH",
         "Oklahoma":"OK",
         "Oregon":"OR",
         "Pennsylvania":"PA",
         "Rhode Island":"RI",
         "South Carolina":"SC",
         "South Dakota":"SD",
         "Tennessee":"TN",
         "Texas":"TX",
         "Utah":"UT",
         "Vermont":"VT",
         "Virginia":"VA",
         "Washington":"WA",
         "Washington D.C.":"DC",
         "West Virginia":"WV",
         "Wisconsin":"WI",
         "Wyoming":"WY",
         "American Samoa":"AS",
         "District of Columbia":"DC",
         "Federated States of Micronesia":"FM",
         "Guam":"GU",
         "Marshall Islands":"MH",
         "Northern Mariana Islands":"MP",
         "Palau":"PW",
         "Puerto Rico":"PR",
         "Virgin Islands":"VI"
      };

   /**
    * Add the specified area to the area map
    * @param strTitle    the title of the area
    * @param strStateCd  the state abbreviation
    * @param shape       the shape object associated with the state
    */
   function addArea(strTitle, strStateCd, shape) {
      m_aAreas.push({
         title: strTitle,
         code: strStateCd,
         shape: shape
      });
   }

   /**
    * Convenience function to add states with the specified offset, scale and filter
    * @param iOffsetX         the x offset, applied before scaling
    * @param iOffsetY         the y offset, applied before scaling
    * @param iScale           the scale (ex: 2 is 2x the size)
    * @param iOffsetXAfter    the x offset, applied after scaling
    * @param iOffsetYAfter    the y offset, applied after scaling
    * @param aFilteredStates  (optional) if provided, addScaledArea will only add the states in the array. Use the full state name
    */
   function addScaledArea(iOffsetX, iOffsetY, iScale, iOffsetXAfter, iOffsetYAfter, aFilteredStates) {
      $.each(window.g_oStateBorders, function(strState, aStateCoords) {
         if (aFilteredStates) {
            if ($.inArray(strState, aFilteredStates) == -1) {
               return;
            }
         }

         var aNewCoordinates = [];

         $.each(aStateCoords, function(iKey, aCoordinates) {
            var iLat = aCoordinates[0],
               iLon = aCoordinates[1],

               /**
                * Convert latitude and longitude to pixel coordinates
                *
                * NOTE: Conversions are from Bing Documentation
                *       http://msdn.microsoft.com/en-us/library/bb259689.aspx
                */
               iSinLat = Math.sin(iLat * Math.PI / 180),
               iPixelX = ((iLon + 180) / 360) * 256 * 2,
               iPixelY = (0.5 - Math.log((1 + iSinLat) / (1 - iSinLat)) / (4 * Math.PI)) * 256 * 2;


            // Apply the scale and offsets
            iPixelX = Math.round((iPixelX + iOffsetX) * iScale) + iOffsetXAfter;
            iPixelY = Math.round((iPixelY + iOffsetY) * iScale) + iOffsetYAfter;

            aNewCoordinates.push({ x: iPixelX, y: iPixelY });
         });

         var shape = m_area.addPolygon(aNewCoordinates);
         addArea(strState, m_stateLookup[strState], shape);
      });
   }

   function addRect(strName, strAbbreviation, x, y, width, height) {
      var shape = m_area.addRect(x, y, width, height);
      addArea(strName, strAbbreviation, shape);
   }

   function addCircle(strName, strAbbreviation, x, y, radius) {
      var shape = m_area.addCircle(x, y, radius);
      addArea(strName, strAbbreviation, shape);
   }

   this.getAreas = function() {
      return m_aAreas;
   };

   this.initialize = function() {
      m_area = new AreaMapCompatibilityLayer($("#nationalmap"))

      /* Add off-map states */
      addRect('Alaska', 'AK', 3, 208, 220, 162);
      addRect('Guam', 'GU', 3, 118, 160, 82);
      addRect('Hawaii', 'HI', 3, 10, 160, 100);
      addCircle('Washington D.C.', 'DC', 779, 305, 7);
      addRect('Washington D.C.', 'DC', 742, 341, 87, 17);

      /* Add all inland states */
      addScaledArea(-77, -175.5, 8.2, 190, 0);

      /* Add rescaled versions of small eastern states */
      addScaledArea(-77, -175.5, 13, -110, 20, [
         "Connecticut",
         "Rhode Island",
         "Massachusetts",
         "New Hampshire",
         "Vermont"
      ]);

      /* Add rescaled versions of the smaller states near D.C. */
      addScaledArea(-77, -175.5, 13, -117, 45, [
         "Maryland",
         "Delaware",
         "New Jersey"
      ]);

      /**
       * NOTE: Use the drawMapOutline to check the positioning of the elements
       *       to ensure that the map is to scale and the boundaries are correct
       */
      //m_area.drawMapOutline();
      m_area.pollMouseEvents();
   }
};

/**
 * Code that uses the generated area map. Keep seperate
 */
function initializeMapInterface(mapGenerator) {
   var m_jScaledMap = $("#scaledMap"),
      imageCache = new ImageCache(),
      aAreas = mapGenerator.getAreas(),
      jMovingImage = $("#movingImage"),

      // The state that a popup is currently showing for
      strPopupStateCode,

      // Whether the mouse is hovering over the popup location
      bHoveringPopup = false,

      bHoveringAnyState = false,

      bHoveringDropdown = false,

      iHideTimeoutId,

      bPopupVisible = false;

   // Dummy div
   var jQtipDiv = $('<div style="width: 220px; padding: 10px;" id="qtipDiv"></div>'),
      jQtip = $("<div />")
      .qtip({
         content: {
            text: jQtipDiv
         },
         position: {
            effect: false,
            target: 'event',
            my: 'center right', // Use the corner...
            at: 'center left', // ...and opposite corner
            viewport: $(window),
            solo: true
         },
         style: {
            tip: {
               border: 10,
               width: 18,
               height: 30,
               offset: 10,
               mimic: 'center'
            },
            classes: 'ui-tooltip-shadow ui-tooltip-' + 'tipsy'
         },
         onUpdateCalled: function(api, actualCorner, position) {
            // The 'actualCorner' attribute is not in the qTip documentation
            // because it was added in lieu of an alternative
            //
            // Here we are repositioning the tip so the 'mimic' arrow
            // is pointing in the correct location
            if (actualCorner.y == 'top') {
               position.top -= 29;
            } else if (actualCorner.y == 'bottom') {
               position.top += 29;
            }
         },
         events: {
            show: function(event, api) {
               bPopupVisible = true;
               //if (m_bLoading) {
               //   $("#qtipDiv").empty();
               //}
            },
            hide: function(event, api) {
               bPopupVisible = false;
               AreaDetails.hideHoverState();
               //AreaDetails.hideHoverState(strPopupStateCode);
               //strPopupStateCode = null;
            }
         },
         show: true,
         prerender: true,
         hide: {
            event: 'unfocus'
         }
      });

   /**
    * Get the rectangular position of an area
    * @param jArea  the jQuery element of an <area />
    * @return an object with the following attributes:
    *         top, left, right, bottom
    */
   function getAreaRect(jArea) {
      var aCoordinates = jArea.attr('coords').split(','),
         iLeft = 9000,
         iTop = 9000,
         iRight = 0,
         iBottom = 0;

      /**
       * Not using $.each here because this is a special loop,
       * which iterates TWO at a time
       */
      for (var i = 0; i < aCoordinates.length; i += 2) {
         var iX = parseInt(aCoordinates[i]),
            iY = parseInt(aCoordinates[i + 1]);

         if (iX < iLeft) {
            iLeft = iX;
         }

         if (iX > iRight) {
            iRight = iX;
         }

         if (iY < iTop) {
            iTop = iY;
         }

         if (iY > iBottom) {
            iBottom = iY;
         }
      }

      return {
         top: iTop,
         left: iLeft,
         right: iRight,
         bottom: iBottom
      };
   }

   // For each area
   $.each(aAreas, function(i, area) {
      var strUrl = '/images/nationalmap/statehovers/' + area.code.toLowerCase() + '-statehover.png';

      // Add the image to the image cache
      imageCache.add(strUrl);
   });

   function showSelectedState() {
      if (!strPopupStateCode) return;
      if (!bPopupVisible) return;

      AreaDetails.showHoverState(strPopupStateCode);
   }

   $(document).ready(function() {
      $("#dropdownContent").hover(function() {
         bHoveringDropdown = true;
      }, function() {
         bHoveringDropdown = false;
      });
   });

   // Start pre-loading images
   imageCache.load(function() {
      var iMouseX = 0,
         iMouseY = 0;

      $(document.body).mousemove(function(event) {
         iMouseX = event.pageX;
         iMouseY = event.pageY;
      });

      $.each(aAreas, function(i, area) {
         var strStateAbbreviation = area.code,

            iShowPopupTimeoutId,

            // Whether the mouse is on the coordinates of the state
            // regardless of whether the popup is open
            bHoveringThisState = false;

         function showThisState() {
            // Do not hide the popup while the user is hovering over it
            if (bHoveringPopup) return;
            if (bHoveringDropdown) return;

            AreaDetails.showHoverState(strStateAbbreviation);

            // Important: User expects timeout to reset
            clearTimeout(iShowPopupTimeoutId);

            iShowPopupTimeoutId = setTimeout(function() {
               // Do not hide the popup while the user is hovering over it
               if (bHoveringPopup) return;
               if (bHoveringDropdown) return;
               if (!bHoveringThisState) return;

               showPopup();
            }, 1000);
         }

         function hideThisState() {
            if (bHoveringDropdown) return;
            if (bHoveringPopup) return;

            if ($.browser.msie && parseInt($.browser.version) < 9) {
               jMovingImage.hide();
            } else {
               jMovingImage.stop(true, true).fadeOut();
            }

            showSelectedState();
         }

         jQtipDiv.hover(function() {
            bHoveringPopup = true;
            showSelectedState();
         }, function() {
            bHoveringPopup = false;

            if (bHoveringThisState) {
               showThisState();
            }
         });

         function showPopup() {
            // Do not move the popup while the user is hovering over it
            if (bHoveringPopup) return;
            if (bHoveringDropdown) return;

            var jInfo = $("<div />"),
               strStateClass = ".stateS" + strStateAbbreviation,
               jClone = $("#listingLaneContainer").find(strStateClass).parent().clone(false);

            Track.doEvent('Find a Home by Map', 'View State on Map', strStateAbbreviation);

            jClone.find(strStateClass).show();
            jInfo.append(jClone);

            jQtipDiv.empty().append(jInfo);

            AreaDetails.showHoverState(strStateAbbreviation);

            // TODO: Detect which way the popup will show up
            // and display the popup +20 or -20 pixels depending
            jQtip.qtip('option', 'position.target', [iMouseX - 20, iMouseY]);
            jQtip.qtip('show');

            strPopupStateCode = strStateAbbreviation;
         }

         $(area.shape).bind('areaMouseOver', function(event) {
            bHoveringAnyState = true;
            bHoveringThisState = true;
            showThisState();

            //Set the css for the background image to show a pointer cursor
            $("#nationalmap").css("cursor", "pointer");
            $("#movingImage").css("cursor", "pointer");

            // Important: User expects timeout to reset
            clearTimeout(iHideTimeoutId);
         }).bind('areaMouseOut', function(event) {
            bHoveringAnyState = false;
            bHoveringThisState = false;
            hideThisState();

            //Set the css for the background image to show a default cursor
            $("#nationalmap").css("cursor", "default");
            $("#movingImage").css("cursor", "default");

            iHideTimeoutId = setTimeout(function() {
               // If the user is NOT hovering over states or the popup
               if (!(bHoveringAnyState || bHoveringPopup)) {
                  // Hide the popup
                  jQtip.qtip('hide');

                  // Hide the hover state
                  AreaDetails.hideHoverState();
               }
            }, 2000);
         }).bind('areaMouseClick', function() {
           //This needs to be a navigation to the state detail page
           var strStateheader = "#headerS" + strStateAbbreviation;
           var stateHeader = $("#listingLaneContainer").find(strStateheader);
           var stateDetailLink = $(stateHeader).attr("href");
           Track.doEvent('Find a Home by Map', 'Click State on Map', strStateAbbreviation);
           location.href = stateDetailLink;
         });
      });
   });
}

/**
 * Waits for a group of images to load
 * Same one used by 21Online ECC slider
 */
var ImageCache = function() {
   var m_iTotal = 0,
      m_iLoaded = 0,
      m_oImages = {},
      m_fnOnLoad;

   function onLoad() {
      m_iLoaded++;

      if (m_iLoaded == m_iTotal) {
         m_fnOnLoad();
      }
   }

   /**
    * Add an image to the cache
    * @param strPath      the path of the image
    * @param fnOnSuccess  (optional) callback when the image is loaded
    *                     there is no guarantee of order though
    * @param fnOnError    (optional) callback when there is an error
    */
   this.add = function(strPath, fnOnSuccess, fnOnError) {
      var img;

      // If the image has already been added
      if (m_oImages[strPath]) {
         img = m_oImages[strPath];

      // If the image has not been added
      } else {
         m_iTotal++;

         img = new Image();
         img.onSuccessCallbacks = [];
         img.onload = function() {
            $.each(img.onSuccessCallbacks, function(i, fnCallback) {
               fnCallback();
            });

            img.loaded = true;
            onLoad();
         };

         img.onErrorCallbacks = [];
         img.onerror = function() {
            $.each(img.onErrorCallbacks, function(i, fnCallback) {
               fnCallback();
            });

            img.loaded = false;
            onLoad();
         };

         m_oImages[strPath] = img;
      }

      if (fnOnSuccess) {
         img.onSuccessCallbacks.push(fnOnSuccess);
      }

      if (fnOnError) {
         img.onErrorCallbacks.push(fnOnError);
      }
   };

   this.loadedSuccessfully = function(strPath) {
      var img = m_oImages[strPath];
      return img.loaded;
   };

   /**
    * Start loading the images
    * @param fnOnLoad  callback for when all the images are loaded
    */
   this.load = function(fnOnLoad) {
      m_fnOnLoad = fnOnLoad;

      $.each(m_oImages, function(strPath, img) {
         img.src = strPath;
      });
   };
};

window.CommunityVideoPlayer = function (options) {
   var m_jOverlay = $(".mainVideo .playerOverlay"),
      m_c21Player = null,
      m_options = $.extend({
            flash: "http://" + window.location.hostname + "/cmsassets/player/mediaplayer-5.8-licensed/player.swf",
            //skin: "http://www.century21.com/cmsassets/player/modieus/modieus.zip"
            skin: "/cmsassets/player/modieus/modieus.zip"
         }, options);

   /**
    * Show the C21Player's dock
    */
   function showDock() {
      m_c21Player.getPlugin("dock").show();

      var is_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
      if (is_chrome) {
         var elSharing = document.getElementById('redundantPlayerContainer_sharing');

         // If running in HTML5 mode
         if (elSharing) {
            // Fix shadow rendering for the share plugin
            // Otherwise the text looks VERY bad
            var aLabels = elSharing.firstChild.getElementsByTagName('label'),
               strTextShadow = "0 0 0 transparent, 0 1px 1px black";

            aLabels[0].style.textShadow = strTextShadow;
            aLabels[1].style.textShadow = strTextShadow;
         }
      }

      var elShareDock = document.getElementById('redundantPlayerContainer_jwplayer_dock');

      // If in HTML5 mode
      if (elShareDock) {
         // Fix the image positioning
         elShareDock.firstChild.firstChild.style.top = "5px";
         elShareDock.firstChild.firstChild.style.left = "5px";
      }
   };

   /**
    * Fire up C21Player
    * @param videoUrl       the video to play
    * @param videoThumbUrl  the thumbnail to display before playing begins
    */
   function initializeC21Player(videoUrl, videoThumbUrl, relatedVideoLink) {
      m_c21Player = jwplayer("redundantPlayerContainer").setup({
         file: videoUrl,
         image: videoThumbUrl,
         alt: 'test',

         plugins: {
            'sharing-3': {
               link: relatedVideoLink,
               code: '<embed src="' + m_options.flash + '" flashvars="file=' + videoUrl + '" width="400" height="300" />'
            },
            "gapro-2": {
               trackingobject: window.ga
            }
         },

         // NOTE: Zip file is used for flash. Raw graphics are used for HTML 5
         // Both are required for the player to function correctly
         // NOTE: You will encounter XSS errors if this resource is located on a different domain
         //skin: "http://dev3.ssantharam.cyberitas.com/tiger/videos/mp4onc21dependencies/modieus/modieus.zip",
         skin: m_options.skin,

         width: 640,
         height: 360,

         flashplayer: m_options.flash,
         modes: [
            {type: 'html5'},
            {type: 'flash', src: m_options.flash}
         ],

         // Background color for the player. Seen in fullscreen
         screencolor: "0x000000"
      });


      m_c21Player.onPlay(function () {
         if (window.ga) {
            Track.doEvent('Video Plays', videoUrl, document.location.href);
         }
      }).onPause(showDock).onComplete(showDock).getPlugin("dock").hide();

      // Creating a playlist fixes an issue where the share form will
      // not display correctly
      m_c21Player.load([
         {
            file: videoUrl,
            image: videoThumbUrl
         }
      ]);

      $('#redundantPlayerContainer_jwplayer_display_image').attr('alt', 'Video Display Image');

      $('#redundantPlayerContainer_jwplayer_controlbar_background').attr('role', 'presentation');

   };

   function initialize() {
      m_jOverlay.click(function () {
         m_jOverlay.hide();
         m_c21Player.play();
      });
   };

   this.play = function () {
      if (m_c21Player.getState() !== "PLAYING") {
         m_c21Player.play().seek(0);
      }
   };

   this.pause = function () {
      if (m_c21Player.getState() === "PLAYING") {
         m_c21Player.pause();
      }
   };

   this.setup = function () {
      var jVideoSection = $("#communityVideoSection"),
         videoData = jVideoSection.data(),
         relatedVideoURL = videoData.videoUrl,
         relatedVideoPreviewURL = videoData.previewUrl,
         relatedVideoLink = window.location.href;

      relatedVideoURL = "https://" + window.location.host + relatedVideoURL;
      initializeC21Player(relatedVideoURL, relatedVideoPreviewURL, relatedVideoLink);
   };

   initialize();
};
